import { format } from "date-fns";

function FormatDateTime(dateTime) {
  return (
    <>{dateTime ? `${format(dateTime, "dd-MMM-yyyy")} ${format(dateTime, "h:mm a")}` : '--'}</>
  );
};

export default FormatDateTime;
